import styles from './legalPage.module.css';
import { useNavigate } from 'react-router-dom';
import { FaArrowLeft } from 'react-icons/fa';

const PrivacyPage = () => {
  const navigate = useNavigate();

  return (
    <div className={styles.page}>
      <div className={styles.topbar}>
        <button className={styles.backBtn} onClick={() => navigate(-1)}>
          <FaArrowLeft />
        </button>
        <span className={styles.topbarTitle}>Politique de Confidentialité</span>
      </div>

      <div className={styles.container}>
        <div className={styles.cover}>
          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '12px', marginBottom: '24px' }}>
            <img src={require('../images/logo.jpeg')} alt="Agora Logo" style={{ width: '64px', height: '64px', borderRadius: '50%', objectFit: 'cover', boxShadow: '0 4px 12px rgba(0,0,0,0.1)' }} />
            <h1 className={styles.appName} style={{ margin: 0 }}>agora</h1>
          </div>
          <h2 className={styles.docTitle}>Politique de Confidentialité</h2>
          <p className={styles.docSubtitle}>Plateforme de débats et d'échanges</p>
          <p className={styles.docDate}>Dernière mise à jour : 4 avril 2026</p>
        </div>

        <Section title="1. Introduction">
          <P>Agora est une plateforme dédiée à la libre confrontation d'idées et aux débats citoyens. Nous nous engageons à protéger la vie privée de nos utilisateurs et à traiter leurs données personnelles avec transparence, conformément aux lois applicables et aux standards internationaux de protection des données.</P>
          <P>Cette politique explique quelles données nous collectons, comment nous les utilisons, les protégeons et les partageons, ainsi que vos droits en tant qu'utilisateur.</P>
        </Section>

        <Section title="2. Données collectées">
          <SubSection title="2.1 Données fournies directement">
            <P>Lors de votre inscription et de l'utilisation d'Agora, nous collectons :</P>
            <Ul items={[
              'Adresse e-mail (authentification et notifications)',
              'Nom d\'utilisateur choisi par vous',
              'Mot de passe (stocké sous forme chiffrée, jamais en clair)',
              'Date de naissance (vérification de l\'âge minimum de 15 ans)',
              'Photo de profil (optionnelle)',
              'Publications, arguments, prises de position (Sides), commentaires et messages',
            ]} />
          </SubSection>
          <SubSection title="2.2 Données collectées automatiquement">
            <Ul items={[
              'Identifiant de socket (fonctionnalités temps réel)',
              'Date et heure des publications et interactions',
              'Adresse IP (sécurité et prévention des abus)',
              'Informations sur les appareils et navigateurs utilisés',
            ]} />
          </SubSection>
        </Section>

        <Section title="3. Utilisation des données">
          <P>Vos données sont utilisées exclusivement pour :</P>
          <Ul items={[
            'Créer et gérer votre compte utilisateur',
            'Vous permettre de lancer des débats et d\'interagir avec la communauté',
            'Envoyer des notifications liées à vos publications et prises de position',
            'Envoyer des codes de vérification OTP lors de l\'inscription',
            'Assurer la sécurité de la plateforme et prévenir les abus',
            'Améliorer les fonctionnalités d\'Agora',
            'Gérer les signalements et la modération de contenu',
          ]} />
          <P>Nous n'utilisons pas vos données à des fins publicitaires. <strong>Agora est une plateforme sans publicité.</strong></P>
        </Section>

        <Section title="4. Partage des données">
          <P>Nous ne vendons, ne louons et ne partageons jamais vos données personnelles avec des tiers à des fins commerciales.</P>
          <P>Vos données peuvent être partagées dans les cas suivants :</P>
          <Ul items={[
            'Avec les autres utilisateurs d\'Agora dans la mesure nécessaire au fonctionnement du réseau (profil public, publications, etc.)',
            'Avec des prestataires techniques assurant l\'hébergement et la livraison d\'e-mails, dans le cadre strict de ces services',
            'Sur réquisition judiciaire ou obligation légale en vigueur au Togo',
          ]} />
        </Section>

        <Section title="5. Conservation des données">
          <P><strong>Compte actif :</strong> Vos données sont conservées aussi longtemps que votre compte est actif.</P>
          <P><strong>Suppression du compte :</strong> Lors de la suppression de votre compte, vos données personnelles sont supprimées dans un délai de 30 jours.</P>
          <P><strong>Données de signalement :</strong> Conservées jusqu'à 12 mois à des fins de sécurité.</P>
        </Section>

        <Section title="6. Sécurité des données">
          <P>Nous mettons en œuvre les mesures de sécurité suivantes :</P>
          <Ul items={[
            'Chiffrement des mots de passe avec bcrypt',
            'Communication sécurisée via HTTPS sur l\'ensemble de la plateforme',
            'Authentification par token JWT avec expiration',
            'Limitation du taux de requêtes pour prévenir les attaques',
            'Vérification de l\'email par code OTP lors de l\'inscription',
            'Accès administrateur séparé avec authentification distincte',
          ]} />
          <P>Malgré ces mesures, aucun système n'est totalement infaillible. En cas de violation de données, nous vous notifierons dans les meilleurs délais.</P>
        </Section>

        <Section title="7. Vos droits">
          <P>Vous disposez des droits suivants concernant vos données :</P>
          <Ul items={[
            'Droit d\'accès : consulter les données que nous détenons sur vous',
            'Droit de rectification : corriger des informations inexactes',
            'Droit à l\'effacement : demander la suppression de votre compte et données',
            'Droit à la portabilité : recevoir vos données dans un format structuré',
            'Droit d\'opposition : vous opposer à certains traitements',
          ]} />
          <P>Pour exercer ces droits, contactez-nous à : <strong>contact@agora-app.com</strong></P>
        </Section>

        <Section title="8. Mineurs">
          <P>L'accès à Agora est réservé aux personnes âgées d'au moins 15 ans. Nous ne collectons pas sciemment de données sur des mineurs de moins de 15 ans.</P>
        </Section>

        <Section title="9. Cookies et stockage local">
          <P>Agora utilise le stockage local (localStorage) du navigateur pour maintenir votre session via un token JWT. Nous n'utilisons pas de cookies de suivi ou de publicité.</P>
        </Section>

        <Section title="10. Modifications de cette politique">
          <P>Nous pouvons mettre à jour cette politique. Toute modification importante vous sera notifiée via l'application. La date de dernière mise à jour est indiquée en haut de ce document.</P>
        </Section>

        <Section title="11. Mentions Légales & Éditeur">
          <P>En vertu de la transparence due à nos utilisateurs, la plateforme Agora est éditée et gérée par :</P>
          <div style={{ 
            display: 'flex', 
            alignItems: 'center', 
            gap: '20px', 
            padding: '24px', 
            background: 'var(--badge-bg)', 
            borderRadius: '16px', 
            margin: '20px 0',
            border: '1px solid var(--border)'
          }}>
             <img 
               src={require('../images/chaga.jpg')} 
               alt="Crédo CHAGA"
               style={{ 
                 width: '70px', 
                 height: '70px', 
                 borderRadius: '50%', 
                 objectFit: 'cover', 
                 border: '3px solid #fff', 
                 boxShadow: '0 4px 12px rgba(0,0,0,0.1)' 
               }} 
             />
             <div>
                <h4 style={{ margin: 0, fontSize: '18px', fontWeight: 800, color: 'var(--text)' }}>Crédo CHAGA</h4>
                <p style={{ margin: '4px 0', fontSize: '14px', color: 'var(--muted)' }}>Fondateur & CEO</p>
                <p style={{ margin: 0, fontSize: '13px', color: 'var(--muted)' }}>a étudié à l'Université de Lomé (Togo 🇹🇬)</p>
             </div>
          </div>
          <P>Crédo CHAGA assure la responsabilité du traitement des données et la direction éditoriale d'Agora, veillant au respect de la liberté d'expression et à la sécurité technique de la plateforme.</P>
        </Section>

        <Section title="12. Contact">
          <P>Pour toute question relative à cette politique de confidentialité :</P>
          <P><strong>Email :</strong> contact@getagora.online</P>
          <P><strong>Application :</strong> Agora — Plateforme de débats et d'échanges</P>
        </Section>

        <div className={styles.footer}>
          <p>Agora s'engage à protéger votre vie privée et à traiter vos données avec transparence et respect.</p>
        </div>
      </div>
    </div>
  );
};

const Section = ({ title, children }) => (
  <section className={styles.section}>
    <h2 className={styles.sectionTitle}>{title}</h2>
    {children}
  </section>
);

const SubSection = ({ title, children }) => (
  <div className={styles.subSection}>
    <h3 className={styles.subSectionTitle}>{title}</h3>
    {children}
  </div>
);

const P = ({ children }) => <p className={styles.paragraph}>{children}</p>;

const Ul = ({ items }) => (
  <ul className={styles.list}>
    {items.map((item, i) => <li key={i}>{item}</li>)}
  </ul>
);

export default PrivacyPage;